module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-modal', {
    ref: "update-team",
    attrs: {
      "hide-footer": "",
      "title": 'Modifier les équipes ',
      "size": "xl"
    }
  }, [_c('div', {
    staticClass: "d-block"
  }, [_c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('div', {
    staticClass: "tab"
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "sm": "3"
    }
  }, [_c('label', [_vm._v("Bureau")])]), _vm._v(" "), _c('b-col', {
    attrs: {
      "sm": "9"
    }
  }, [_c('b-row', [_c('b-button-group', [_vm._l((_vm.officeList), function(desk, name, index) {
    return _c('b-button', {
      key: index,
      attrs: {
        "variant": "outline-primary",
        "pressed": name == _vm.officeSelected
      },
      on: {
        "click": function($event) {
          return _vm.selectOffice(name)
        }
      }
    }, [_vm._v("\n                  " + _vm._s(name) + "\n                ")])
  }), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "outline-primary",
      "pressed": _vm.isAddingOffice
    },
    on: {
      "click": function($event) {
        return _vm.addOffice()
      }
    }
  }, [_vm._v("\n                  Autre\n                ")])], 2)], 1), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.isAddingOffice) ? _c('b-row', [_c('b-col', {
    attrs: {
      "sm": "9"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "formatter": _vm.formatterLower
    },
    model: {
      value: (_vm.officeInput),
      callback: function($$v) {
        _vm.officeInput = $$v
      },
      expression: "officeInput"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "sm": "3"
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "primary",
      "disabled": !_vm.officeInput
    },
    on: {
      "click": function($event) {
        _vm.officeSelected = _vm.officeInput
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-plus"
  }), _vm._v("\n                  Ajouter\n                ")])], 1)], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.officeSelected) ? _c('b-row', [_c('b-col', {
    attrs: {
      "sm": "3"
    }
  }, [_c('label', [_vm._v("Equipe")])]), _vm._v(" "), _c('b-col', {
    attrs: {
      "sm": "9"
    }
  }, [(!_vm.isAddingOffice) ? _c('b-row', [_c('b-button-group', [_vm._l((_vm.teamList), function(name, index) {
    return _c('b-button', {
      key: index,
      attrs: {
        "variant": "outline-primary",
        "pressed": name == _vm.teamSelected
      },
      on: {
        "click": function($event) {
          return _vm.selectTeam(name)
        }
      }
    }, [_vm._v("\n                " + _vm._s(name) + "\n                ")])
  }), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "outline-primary",
      "pressed": _vm.isAddingTeam
    },
    on: {
      "click": function($event) {
        return _vm.addTeam()
      }
    }
  }, [_vm._v("\n                  Autre\n                ")])], 2)], 1) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.isAddingTeam) ? _c('b-row', [_c('b-col', {
    attrs: {
      "sm": "9"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "formatter": _vm.formatterLower
    },
    model: {
      value: (_vm.teamInput),
      callback: function($$v) {
        _vm.teamInput = $$v
      },
      expression: "teamInput"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "sm": "3"
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "primary",
      "disabled": !_vm.teamInput
    },
    on: {
      "click": function($event) {
        _vm.teamSelected = _vm.teamInput
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v("\n                  Ajouter\n                ")])], 1)], 1) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.teamSelected) ? _c('b-row', [_c('b-col', {
    attrs: {
      "sm": "3"
    }
  }, [_c('label', [_vm._v("Membre")])]), _vm._v(" "), _c('b-col', {
    attrs: {
      "sm": "9"
    }
  }, [(_vm.memberList.length !== 0) ? _c('b-row', _vm._l((_vm.memberList), function(name, index) {
    return _c('b-button', {
      key: index,
      staticStyle: {
        "margin-right": "1rem"
      },
      attrs: {
        "pill": "",
        "variant": "outline-danger"
      },
      on: {
        "click": function($event) {
          return _vm.removeMember(name)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-times"
    }), _vm._v("\n                " + _vm._s(name) + "\n              ")])
  }), 1) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "sm": "9"
    }
  }, [_c('b-input', {
    attrs: {
      "b-form-input": "",
      "type": "text",
      "placeholder": "SGRI",
      "formatter": _vm.formatterUpper,
      "maxlength": "4"
    },
    model: {
      value: (_vm.memberName),
      callback: function($$v) {
        _vm.memberName = $$v
      },
      expression: "memberName"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "sm": "3"
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.addMember()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v("\n                  Ajouter\n                ")])], 1)], 1)], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow": "auto"
    }
  }, [_c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('b-button', {
    staticClass: "mt-3",
    attrs: {
      "variant": "info"
    },
    on: {
      "click": function($event) {
        return _vm.save()
      }
    }
  }, [_vm._v("\n            Enregistrer\n          ")])], 1)])])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-354894b2","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/TeamsUpdateModal.vue
// module id = 709
// module chunks = 1